// Shipping region codes
export const EVERYWHERE_CODE = 'XX';
export const US_CON = 'US_CON';
export const US_AK = 'US_AK';
export const US_HI = 'US_HI';
export const US_PR = 'US_PR';
export const US_OTHER = 'US_OTHER';

export const AFFIRM_SUPPORTED_SHIPPING_REGIONS = [
  EVERYWHERE_CODE,
  US_CON,
  US_AK,
  US_HI,
  US_PR,
  US_OTHER,
];

// Country codes
export const US = 'US';

export const NUMBER_OR_FLOAT_KEYS_REGEX = /\d|\.|\,|\s/;

export const experiments = {
  OFFER_QUANTITY: 'offer_quantity',
  CART_RECENTLY_VIEWED_ROW: 'cart_recently_viewed_row',
  ITEM_LOGGED_OUT_RECENTLY_VIEWED: 'item_logged_out_recently_viewed',
  CSP_NO_INVENTORY: 'csp_no_inventory',
  OFFER_RECS: 'offer_recs',
  V3_OFFERS: 'v3_offers',
  CSP_BUYBOX_LAUNCH: 'csp_buybox_launch',
  RECENT_SEARCH_SUGGESTIONS: 'recent_search_suggestions',
  CSP_RECENT_LISTINGS: 'csp_recent_listings',
  LISTING_CARD_NEW_TAB: 'listing_card_new_tab',
  I2_COMBINED_SHIPPING_CALLOUT: 'i2_combined_shipping_callout',
  NEO_MARKETPLACE: 'neo_marketplace',
  ONE_COLUMN_CSP: 'one_column_csp',
  ITEM2_FEEDBACK: 'item2_feedback',
  SECONDARY_ITEM_ROWS: 'secondary_item_rows',
};

export const CORE_DEFAULT_OG_IMAGE_URL =
  'https://static.reverb-assets.com/assets/homepage/open-graph-2a0cbbc49a26d873db03aae487defc6d.jpg';

export const LP_NATIVE = 'lp_native';
export const IOS = 'ios';
export const ANDROID = 'android';
export const MOBILE_PHONE = 'mobile_phone';
export const TABLET = 'tablet';
export const WEB = 'web';

export enum CmsPageType {
  BUYING_GUIDE = 'buying_guide',
  CATEGORY = 'category',
  FEATURED = 'featured',
  GEAR = 'gear',
  LEGAL = 'legal',
  PRESS = 'press',
  PROMO = 'promo',
  ROOT = 'root',
  SALE = 'sale',
  SELLING = 'selling',
}

export enum ExperimentBucketType {
  NULL = '',
  DEFAULT = 'default',
  EXPERIMENT = 'experiment',
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/constants.ts